import { $ } from '../utils/element';

export function getFormContainerId(element: HTMLElement): string {
    const formContainer = $(element).findParent(`[${formContainerIdAttr}]`);
    return formContainer ? formContainer.getAttr(formContainerIdAttr) : '';
}

export const formContainerIdAttr = 'form-container-id';
